import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { getFilterConfigItemByColumnTypeAndSelectedOperator, getFilterOperatorListByColumnType } from "@common-reducers/TasksFilterPanelThunks";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import React from 'react';
import { usePortalContainer } from "@/common/hooks/use-portal-container";

interface FilterRowOperatorFieldProps {
    operatorField: string;
    onOperatorChange: (value: string) => void;
    selectedColumnType: string;
}

export const FilterRowOperatorFieldShadcn: React.FC<FilterRowOperatorFieldProps> = ({
    operatorField,
    onOperatorChange,
    selectedColumnType,
}) => {
    const operatorsList = useAppSelector((state) => getFilterOperatorListByColumnType(state, selectedColumnType));
    const selectedFilterItemOperator = useAppSelector((state) => getFilterConfigItemByColumnTypeAndSelectedOperator(state, selectedColumnType, operatorField));
    const localPortalContainer = usePortalContainer();

    const handleChange = (value: string) => {
        onOperatorChange(value);
    };

    const currentValue = operatorField ?? selectedFilterItemOperator?.value ?? '';

    return (
        <Select 
            value={currentValue} 
            onValueChange={handleChange}
        >
            <SelectTrigger className="w-full h-9">
                <SelectValue placeholder="Condition" />
            </SelectTrigger>
            <SelectContent>
                {operatorsList && operatorsList.map((operator: string) => (
                    <SelectItem key={operator} value={operator}>
                        {operator}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
